/*
 * Treat — one toast for messages that have no visible home of their own.
 *
 * A product card has no error line, and the sticky add-to-cart bar submits the main product form
 * whose error line may be scrolled out of view. Without this, a refused add (already at the
 * stock limit, variant just sold out) failed silently: the button simply turned into "Sold out".
 * product-form.js calls window.treatToast(message) when the form's own error line is not visible.
 *
 * Markup: the [data-treat-toast] element in layout/theme.liquid. Colours invert the page scheme.
 */
(() => {
  if (window.treatToast) return;

  let timer;
  let hideTimer;

  window.treatToast = (message) => {
    const toast = document.querySelector('[data-treat-toast]');
    if (!toast || !message) return;
    window.clearTimeout(hideTimer);
    const text = toast.querySelector('[data-treat-toast-text]');
    text.textContent = message;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.clearTimeout(timer);
    timer = window.setTimeout(hide, 6000);
  };

  const hide = () => {
    const toast = document.querySelector('[data-treat-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    hideTimer = window.setTimeout(() => {
      toast.hidden = true;
    }, 200);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-treat-toast-close]')) hide();
  });

  document.addEventListener('keyup', (event) => {
    if (event.code === 'Escape') hide();
  });
})();
